'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})
exports.bold = exports.regular = exports.caps = undefined

var _extends =
  Object.assign ||
  function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i]
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key]
        }
      }
    }
    return target
  }

var _react = require('react')

var _react2 = _interopRequireDefault(_react)

var _styledComponents = require('styled-components')

var _styledComponents2 = _interopRequireDefault(_styledComponents)

var _propTypes = require('prop-types')

var _propTypes2 = _interopRequireDefault(_propTypes)

var _styledSystem = require('styled-system')

var _theme = require('./theme')

var _theme2 = _interopRequireDefault(_theme)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

var caps = (exports.caps = function caps(props) {
  return props.caps ? { textTransform: 'uppercase' } : null
})

var regular = (exports.regular = function regular(props) {
  return props.regular ? { fontWeight: props.theme.regular } : null
})

var bold = (exports.bold = function bold(props) {
  return props.bold ? { fontWeight: props.theme.bold } : null
})

var Base = function Base(props) {
  var next = (0, _theme.filterProps)(props)
  return _react2.default.createElement('p', next)
}

var Text = (0, _styledComponents2.default)(Base)(
  [],
  _styledSystem.fontSize,
  _styledSystem.space,
  _styledSystem.color,
  caps,
  _styledSystem.textAlign,
  bold,
  regular,
  _styledSystem.fontWeight
)

Text.displayName = 'Text'

Text.propTypes = _extends(
  {
    caps: _propTypes2.default.bool,
    regular: _propTypes2.default.bool,
    bold: _propTypes2.default.bool
  },
  _styledSystem.propTypes.fontSize,
  _styledSystem.propTypes.fontWeight,
  _styledSystem.propTypes.textAlign,
  _styledSystem.propTypes.space,
  _styledSystem.propTypes.color
)

Text.defaultProps = {
  theme: _theme2.default,
  m: 0
}

Text.span = Text.withComponent('span')
Text.p = Text.withComponent('p')
Text.s = Text.withComponent('s')

exports.default = Text



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/Text.js
// module id = 54
// module chunks = 168707334958949